export default "/images/why_work_with_us/complexity_of_tokenomics.png";